import { Component, OnInit, OnDestroy, EventEmitter, Output, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  TaxCodeCfgService,
  TaxCodeContainerModel
} from 'blg-akaun-ts-lib';
import { ReplaySubject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SubSink } from 'subsink2';
import { AppConfig } from '../../visa';

@Component({
  selector: 'app-wht',
  templateUrl: './wht.component.html',
  styleUrls: ['./wht.component.css']
})
export class WHTComponent implements OnInit, OnDestroy {

  @Input() wht: FormControl;

  @Output() whtChange = new EventEmitter<FormControl>();
  @Output() whtContainer = new EventEmitter<TaxCodeContainerModel>();

  private subs = new SubSink();

  private apiVisa = AppConfig.apiVisa;
  filterControl = new FormControl();
  filteredOptions$: ReplaySubject<TaxCodeContainerModel[]> = new ReplaySubject<TaxCodeContainerModel[]>(1);
  whtList: TaxCodeContainerModel[];

  constructor( private taxService: TaxCodeCfgService ) {}

  ngOnInit() {
    this.subs.sink = this.taxService.get(this.apiVisa).subscribe(
      {next: resolve => {
        this.whtList = resolve.data.filter(s => s.bl_fi_cfg_tax_code.tax_wht_type);
        this.filteredOptions$.next(this.whtList);
      }});
    // if (this.currency.value) {
    //   this.subs.sink = this.currencyService.getByGuid(this.currency.value, this.apiVisa).subscribe( resolved => {
    //     this.branchList = [resolved.data];
    //     this.filteredOptions$.next([resolved.data]);
    //     this.onSelect(resolved.data.bl_fi_mst_branch.guid.toString());
    //   });
    // }
    this.subs.sink = this.filterControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe({next: resolve => this.filterWHT(resolve)});
  }

  filterWHT(search: string) {
    if (!search) {
      this.filteredOptions$.next(this.whtList);
    } else {
      search = search.toLocaleLowerCase();
      const filter = this.whtList.filter(s => s.bl_fi_cfg_tax_code.tax_code.toLowerCase().includes(search.toLowerCase().toString()));
      this.filteredOptions$.next(filter);
    }
  }

  onSelectionChange(e: string) {
    const container = this.whtList.find(c => c.bl_fi_cfg_tax_code.tax_code === e);
    this.whtContainer.emit(container);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
